import {
    EntityApiKeyCreatedDto,
    EntityApiKeyDto,
} from "@entity-api-keys/data/dto/entity-api-key.dto";
import {
    CreatedEntityApiKey,
    EntityApiKey,
} from "@entity-api-keys/domain/models/entity-api-key.model";
import { validateSync } from "class-validator";
import { injectable } from "inversify";
import { DateTime } from "luxon";

@injectable()
export class EntityApiKeyMapper {
    map(dto: EntityApiKeyDto): EntityApiKey | null {
        const errors = validateSync(dto);
        if (Boolean(errors.length)) {
            console.error(errors);
            return null;
        }

        return new EntityApiKey(
            dto.id,
            dto.entity,
            dto.name ?? "",
            dto.prefix,
            dto.scopes ?? [],
            dto.is_active,
            DateTime.fromISO(dto.created),
            DateTime.fromISO(dto.modified),
        );
    }

    mapCreated(dto: EntityApiKeyCreatedDto): CreatedEntityApiKey | null {
        const errors = validateSync(dto);
        if (Boolean(errors.length)) {
            console.error(errors);
            return null;
        }

        const apiKey = this.map(dto);
        if (!apiKey) return null;

        return new CreatedEntityApiKey(apiKey, dto.plaintext_key);
    }
}
